import { useActivePromotion } from "@/hooks/useActivePromotion";

const formatFR = (dateLike) => {
  if (!dateLike) return "";
  try {
    const d = new Date(dateLike);
    if (isNaN(d.getTime())) return "";
    return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" });
  } catch {
    return "";
  }
};

/**
 * Top banner displayed on every page when a promotion is active.
 * Silent when no promo (no layout shift).
 */
export const PromoBanner = () => {
  const { promo } = useActivePromotion();
  if (!promo || !promo.discount_value) return null;
  const isPct = promo.discount_type === "percentage";
  const label = isPct ? `-${promo.discount_value}%` : `-${promo.discount_value}€`;
  const code = promo.code || promo.title || "PROMO";
  const endDate = formatFR(promo.end_date);
  return (
    <div
      data-testid="promo-banner"
      style={{
        background: "#b8977e",
        color: "#fff",
        textAlign: "center",
        padding: "8px 16px",
        fontFamily: "'DM Sans', sans-serif",
        fontSize: 13,
        letterSpacing: "0.04em",
        position: "relative",
        zIndex: 60,
      }}
    >
      🎉 Code <strong data-testid="promo-banner-code">{code}</strong> — {label} sur tous les forfaits
      {endDate ? ` jusqu'au ${endDate}` : ""}
    </div>
  );
};

export default PromoBanner;
